import { useEffect, useState } from 'react';
import { useCookies } from 'react-cookie';

const Popup = () => {
  const [showPopup, setShowPopup] = useState(false);
  const [cookieAlready, setCookieAlready] = useState(false);
  const [cookies, setCookie] = useCookies(['cookieyes-consent']);

  const parseConsentCookie = (cookie) => {
    if(!cookie) return [];
    return Object.fromEntries(
      cookie?.split(',').map((pair) => {
        const [key, value] = pair.split(':');
        return [key.trim(), value.trim()];
      }),
    );
  };

  useEffect(() => {
    const consentCookie = cookies['cookieyes-consent'];
    const consentObj = parseConsentCookie(consentCookie);
    if (consentObj.consent === 'yes') {
      setCookieAlready(true);
    }
  }, []);

  useEffect(() => {
    const handleAcceptClick = () => {
      setCookieAlready(true);
    };
    // Wait for DOM and CookieYes to load
    const interval = setInterval(() => {
      const acceptBtn = document.querySelector('.cky-btn-accept');
      if (acceptBtn) {
        acceptBtn.addEventListener('click', handleAcceptClick);
        clearInterval(interval); // Stop checking once found
      }
    }, 300);
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowPopup(true);
    }, 5000);

    return () => clearTimeout(timer);
  }, []);

  const onClose = () => {
    setShowPopup(false);
  };

  return (
    <>
      {showPopup && cookieAlready ? (
        <div className="popup-overlay-new">
          <div className="popup">
            <div className="popup__close-button" onClick={onClose}>
              <img src="/images/popup-x.png" width="18" height="18" />
            </div>
            <img
              className="popup__image"
              src="/images/popup-logo.png"
              width="103px"
              height="45px"
            />
            <h4 className="popup__info">Do I Have a Case?</h4>
            <h6 className="popup__text">Free Instant Assessment</h6>
            <a className="popup__button button" href="/do-i-have-a-case">
              Get Started
            </a>
          </div>
        </div>
      ) : (
        <></>
      )}
    </>
  );
};

export default Popup;
